import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';



@Component({
  selector: 'app-admin-update-guidelines-dialog',
  templateUrl: './admin-update-guidelines-dialog.component.html',
  styleUrl: './admin-update-guidelines-dialog.component.css',
})
export class AdminUpdateGuidelinesDialogComponent implements OnInit {
  dataSource=new MatTableDataSource
  
  columns=['product','facings']
  static_data=[{product:"coco cola",shelf:"SS",facings:3},{product:"thump ups",shelf:"SS",facings:3},{product:"maza",shelf:"SS",facings:3},{product:"lime",shelf:"SS",facings:3}]
  constructor(
    public dialogRef: MatDialogRef<AdminUpdateGuidelinesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) {}
  ngOnInit(): void {
    this.dataSource.data=this.data
  }

  
}
